import type { ToolRendererProps } from '@chatsdet/ui';
import { Text } from '@chatsdet/ui';
import type { PresentResultsInput, PresentResultsOutput } from '../types';

/**
 * Keep inline chat representation minimal — the actual chart/table renders on
 * the canvas. Here we just label the chosen visualization.
 */
export function PresentResultsRenderer({
  input,
  output,
}: ToolRendererProps<PresentResultsInput, PresentResultsOutput>) {
  const title = output?.title ?? input?.title;
  const renderType = output?.renderType ?? input?.renderType;
  if (!title && !renderType) return null;
  return (
    <Text size="xs" className="text-muted-foreground">
      Rendered <span className="font-medium">{renderType?.replace('_', ' ')}</span>
      {title ? ` — ${title}` : ''}
    </Text>
  );
}
